const SeoOpenGraph = `
  fragment SeoOpenGraph on SeoOpenGraph {
    description
    facebookAppId
    title
    image {
      url
    }
  }
`

export default SeoOpenGraph
